export enum ValidityLength {
  MORE_THAN_10_YEARS = 'MORE_THAN_10_YEARS',
  '5_TO_10_YEARS' = '5_TO_10_YEARS',
  '2_TO_5_YEARS' = '2_TO_5_YEARS',
  LESS_THAN_2_YEARS = 'LESS_THAN_2_YEARS',
}
